export default __webpack_public_path__ + "static/media/logo-aspel.fabbdc92.svg";